import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { connect } from 'react-redux';
import { defer } from 'lodash';
import FormData from 'form-data';

import draftToHtml from 'draftjs-to-html';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { FormGroup, ControlLabel, FormControl,
  HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import Toggle from 'react-bootstrap-toggle';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import CheckboxGroup from '../../../../components/checkbox-group';
import Editor from '../../../../components/editor';
import { requestAddNews, requestUpdateNews, requestUploadFile } from '../../AdminActions';
import ImageUpload from './ImageUpload';
import styles from './styles.css';

let htmlToDraft = () => null;

const typeOptions = [
  { value: 'news', label: 'News' },
  { value: 'newFeature', label: 'New Feature' },
  { value: 'enhancement', label: 'Enhancement' },
  { value: 'planned', label: 'Planned' },
  { value: 'resolvedIssue', label: 'Resolved Issue' },
  { value: 'knownIssue', label: 'Known Issue' },
  { value: 'other', label: 'Other' },
];

class NewsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: null,
      focus: false,
      ready: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.onToggleVisibility = this.onToggleVisibility.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.renderDatePicker = this.renderDatePicker.bind(this);
    this.renderEditor = this.renderEditor.bind(this);
    this.uploadImageCallBack = this.uploadImageCallBack.bind(this);
  }

  componentDidMount() {
    import('html-to-draftjs').then((f)=> {
      htmlToDraft = f.default;
      const { news } = this.props;
      const { description } = news;
      // todo: if start with an iframe
      let rawDescription = description || '';
      if (rawDescription.indexOf('<iframe ') === 0) {
        rawDescription = `<p></p>${rawDescription}`;
      }
      const contentBlock = htmlToDraft(rawDescription);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      this.setState({
        ready: true,
        editorState,
        focus: false,
      });
    });
  }

  onEditorStateChange(editorState) {
    this.setState({
      editorState,
    });
    const description = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    this.props.change('description', description);
  }

  onToggleVisibility() {
    const { isVisible } = this.props;
    this.props.change('is_visible', !isVisible);
  }

  handleDateChange(date) {
    this.props.change('announcement_date', date ? date.format('YYYY-MM-DD') : null);
  }

  handleFocus() {
    this.setState({ focus: true });
  }
  handleBlur() {
    this.setState({ focus: false });
  }

  handleSubmit(data) {
    const { news } = this.props;
    const isNew = news._id === undefined;
    const action = isNew ? requestAddNews(data) : requestUpdateNews(news._id, data);
    return this.props.dispatch(action)
      .then(
        () => {
          // redirect
          defer(this.context.router.history.push, '/admin/news');
        },
        (errors) => {
          throw new SubmissionError(errors.data || errors);
        },
      );
  }

  uploadImageCallBack(file) {
    const data = new FormData();
    data.append('file', file);
    return this.props.dispatch(requestUploadFile(data));
  }

  renderField({
    input, label, type, componentClass, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className="">
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...input} componentClass={componentClass} placeholder={label} type={type} disabled={submitting} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  renderDatePicker({
    label, date, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={styles.datePicker}>
        <ControlLabel>{label}</ControlLabel>
        <DatePicker
          dateFormat="DD MMM YYYY"
          className="form-control clickable"
          selected={date}
          showYearDropdown
          disabled={submitting}
          scrollableYearDropdown
          onChange={this.handleDateChange}
        />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  renderEditor({
    label, editorState, focus, meta: { touched, error },
  }) {
    const { ready } = this.state;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={styles.descriptionEditor}>
        <ControlLabel>{label}</ControlLabel>
        <Editor
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          wrapperClassName={styles.editorWrapper}
          editorClassName={`${styles.editor} ${focus ? styles.editorFocus : ''}`}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          toolbar={{
            options: [
              'inline', 'blockType', 'fontSize',
              'fontFamily', 'list', 'textAlign', 'colorPicker',
              'link', 'emoji', 'remove', 'history',
            ],
            inline: {
              options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript'],
            },
          }}
          toolbarCustomButtons={ready ? [
            <ImageUpload
              config={{
                uploadCallback: this.uploadImageCallBack,
                previewImage: true,
                urlEnabled: false,
                uploadEnabled: true,
                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg,video/webm',
                alt: { present: false, mandatory: false },
                defaultSize: {
                  height: 'auto',
                  width: 'auto',
                },
              }}
            />,
          ] : []}
        />

        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  render() {
    const {
      handleSubmit, submitting, news,
      isVisible, announcementDate,
    } = this.props;
    const { editorState, focus } = this.state;
    const isNew = !news._id;
    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="panel panel-default">
          <div className="panel-heading">
            {isNew && <span>Add New Announcement</span>}
            {!isNew && <span>Edit Announcement</span>}
          </div>
          <div className="panel-body">

            <Field
              name="title"
              type="text"
              component={this.renderField}
              label="Title"
            />

            <Field
              name="types"
              label="Types"
              component={CheckboxGroup}
              options={typeOptions}
            />

            <Field
              name="announcement_date"
              date={announcementDate}
              component={this.renderDatePicker}
              label="Announcement Date"
            />


            <Field
              name="description"
              focus={focus}
              editorState={editorState}
              component={this.renderEditor}
              label="Description"
            />

            <FormGroup>
              <ControlLabel>Visibility:</ControlLabel>
              <div>
                <Toggle
                  onClick={this.onToggleVisibility}
                  on={<span>Visible</span>}
                  off={<span>Hidden</span>}
                  size="xs"
                  onstyle="success"
                  offstyle="danger"
                  active={isVisible}
                />
              </div>
            </FormGroup>
          </div>
          <div className="panel-footer text-right">
            <div className="clearfix">
              <Link className="btn btn-link pull-left" to="/admin/news">
                <Fa name="arrow-left" /> Cancel
              </Link>
              <button className="btn btn-primary pull-right" disabled={submitting}>
                <span>
                  <Fa spin={submitting} name={submitting ? 'spinner' : 'check'} />
                  {submitting && <span>Saving</span>}
                  {!submitting && <span>Save</span>}
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const selector = formValueSelector('newsForm'); // <-- same as form name
// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const dateRaw = selector(state, 'announcement_date');
  const announcementDate = dateRaw ? moment(dateRaw, 'YYYY-MM-DD') : null;
  return {
    initialValues: { ...ownProps.news },
    isVisible: selector(state, 'is_visible'),
    announcementDate,
  };
}

NewsForm.propTypes = {
  initialize: PropTypes.func,
  isVisible: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  change: PropTypes.func,
  news: PropTypes.shape({}).isRequired,
  announcementDate: PropTypes.instanceOf(moment),
};
NewsForm.defaultProps = {
  isVisible: false,
  announcementDate: null,
  change: () => {},
  handleSubmit: () => {},
  submitting: false,
  initialize: () => {},
};
NewsForm.contextTypes = {
  router: PropTypes.object,
};

const NewsFormForm = reduxForm({
  form: 'newsForm',
})(NewsForm);

export default connect(mapStateToProps)(NewsFormForm);
